// @ts-nocheck
import { useCallback } from 'react';

import useCommon from '../../../../hooks/useCommon';
import { useWorkflowGroupsQuery } from '../api/workflowQueries';

const useWorkflowGroups = () => {
  const { execute: getWorkflowGroups } = useWorkflowGroupsQuery({
    options: {
      enabled: false, // don't fetch on mount, we'll call when needed
      loader: false,
    },
  });

  const { setWorkflowGroupNodes, setCurrentWorkflowGroupId, dispatch } =
    useCommon();

  const fetchWorkflowGroups = useCallback(
    ({
      template_id,
      template_version_id,
      entity_current_status = null,
      entity_id = null,
    }) => {
      getWorkflowGroups({
        params: { template_id, version_id: template_version_id },
      }).then((data) => {
        if (data) {
          const nodes = data.map((group) => {
            return {
              label: group?.group_name,
              value: group?.workflow_group_id,
              ...group,
            };
          });
          dispatch(setWorkflowGroupNodes({ entity_id, data: nodes }));
          // Find the workflow group whose states include the entity's current status.
          // Falls back to the first group if no match is found.
          const matchedNode = nodes?.find((node) =>
            node?.states?.includes(entity_current_status)
          );
          const currentGroupId =
            matchedNode?.workflow_group_id ?? nodes[0]?.workflow_group_id;
          dispatch(
            setCurrentWorkflowGroupId({
              entity_id,
              data: currentGroupId,
            })
          );
        }
      });
    },
    [
      getWorkflowGroups,
      setWorkflowGroupNodes,
      setCurrentWorkflowGroupId,
      dispatch,
    ]
  );

  return { fetchWorkflowGroups };
};

export default useWorkflowGroups;
